import { useMutation } from '@tanstack/react-query';
import { resolveOabOffer } from './api';

export function useResolveOabOffer() {
  return useMutation(resolveOabOffer);
}
